<div class="subBlockContent" id="confirmAMPProduct">
  <child-header [title]="'Confirm Products'" (closeEvent)="close()"></child-header>
  <loading-screen *ngIf="!loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
    (currentLoadingStatus)="onLoading($event)">
  </loading-screen>

  <div class="inner-subBlock-wrapper child-body">

    <div class="pannel-outter-wrapper">
      <!-- Subscription -->
      <ng-container>

        <div class="wrapper center-block panel-wrapper-margin">
          <div class="panel-group" id="accordionSubscription" role="tablist" aria-multiselectable="true">
            <div class="panel panel-default">
              <div class="panel-heading active" role="tab" id="headingSubscription">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#accordionSubscription"
                    href="#collapseSubscription" aria-expanded="true" aria-controls="collapseSubscription">
                    <span class="highlight-text">SUBSCRIPTION</span>
                    <span class="panel-subtitle" id="panelsubtitle">
                      {{ subscriptionItemsPendingList?.length?subscriptionItemsPendingList?.length:"0" }}
                      Subscription(s)
                      <span class="triangle-down"></span>
                    </span>
                  </a>
                </h4>
                <div id="collapseSubscription" class="panel-collapse collapse in show" role="tabpanel"
                  aria-labelledby="headingSubscription">
                  <div class="panel-body">
                    <div class="panel-content">
                      <div class="inner-subBlock-content">
                        <div>
                          <div class="mTable">
                            <table mat-table [dataSource]="subscriptionItemsPendingList" multiTemplateDataRows style="display: inline-table; width: 100%;">
                              <!-- desc -->
                              <ng-container matColumnDef="desc">
                                <th mat-header-cell *matHeaderCellDef scope="col" style="padding: .75rem .75rem .75rem 50px; width: 35%">DESCRIPTION</th>
                                <td mat-cell *matCellDef="let p" style="padding: .75rem .75rem .75rem 50px; width: 35%">
                                  <div class="description" style="white-space: nowrap;">
                                    {{p?.description}}
                                  </div>
                                  <div class="result-info">
    
                                    <div class="produc-secondary-title-wrapper pt-2">
                                      <span>STOCK CODE:&nbsp;</span>
                                      <span class="red-bold">{{p?.previewStockCode}}</span>
                                    </div>
                                  </div>
                                </td>
                              </ng-container>

                              <!-- qty -->
                              <ng-container matColumnDef="qty">
                                <th style="padding: .75rem .75rem .75rem .75rem; text-align: center; width: 8%" 
                                  mat-header-cell *matHeaderCellDef>QTY</th>
                                <td style="padding: .75rem .75rem .75rem .75rem; text-align: center; width: 8%" 
                                  mat-cell *matCellDef="let p">
                                  <input
                                    type="text"
                                    class="align-center input-wrapper input-wrapper-small"
                                    [disabled]="loadingPreview"
                                    (blur)="quantityChange(p)"
                                    [(ngModel)]="p.newQuantity"
                                  >
                                </td>
                              </ng-container>

                              <!-- rrp -->
                              <ng-container matColumnDef="rrp">
                                <th style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 18%" 
                                  mat-header-cell *matHeaderCellDef>UNIT RRP</th>
                                <td style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 18%" 
                                  mat-cell *matCellDef="let p">
                                  <div>
                                    <span>{{p?.itemRRPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                  </div>
                                  <div *ngIf="p?.showProratedPrice && !createScheduled">
                                    <span>Prorated:&nbsp;&nbsp;{{p?.proratedRRP | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                  </div>
                                </td>
                              </ng-container>

                              <!-- price -->
                              <ng-container matColumnDef="price">
                                <th style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 18%" 
                                  mat-header-cell *matHeaderCellDef>UNIT PRICE</th>
                                <td style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 18%" 
                                  mat-cell *matCellDef="let p">
                                  <div>
                                    <span>{{ p?.itemPrice | currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                  </div>
                                  <div *ngIf="p?.showProratedPrice && !createScheduled">
                                    <span>{{ p?.proratedPrice | currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                  </div>
                                </td>
                              </ng-container>

                              <!-- total -->
                              <ng-container matColumnDef="total">
                                <th style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 16%" 
                                  mat-header-cell *matHeaderCellDef>TOTAL</th>
                                <td style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 16%" 
                                  mat-cell *matCellDef="let p">
                                  <div>
                                    <span *ngIf="p?.showProratedPrice && !createScheduled;else showOther">
                                      &nbsp;
                                    </span>
                                    <ng-template #showOther>
                                      <span>
                                        {{ p?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2' }}
                                      </span>
                                    </ng-template>
                                  </div>
                                  <div *ngIf="p?.showProratedPrice && !createScheduled">
                                    <span>{{ p?.proratedTotal| currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                  </div>
                                </td>
                              </ng-container>

                              <!-- delete button -->
                              <ng-container matColumnDef="deleteButton">
                                <th style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 5%" 
                                  mat-header-cell *matHeaderCellDef></th>
                                <td style="padding: .75rem .75rem .75rem .75rem; text-align: right; width: 5%" 
                                  mat-cell *matCellDef="let p;let i = index;">
                                  <span id="delete-icon" class="basic-icon delete-icon"
                                    (click)="removeSubscriptionPendingItem(i)" ngbTooltip="Remove"
                                    placement="bottom">
                                  </span>
                                </td>
                              </ng-container>


                              <ng-container matColumnDef="expand">
                                <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                <td mat-cell *matCellDef="let p">
                                  <button
                                    mat-icon-button
                                    aria-label="expand row"
                                    (click)="toggle(p); $event.stopPropagation()"
                                    class="example-toggle-button"
                                    [class.example-toggle-button-expanded]="isExpanded(p)">
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                  </button>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let p" [attr.colspan]="columnsToDisplayWithExpand.length">
                                  <div class="example-element-detail-wrapper" 
                                    [class.example-element-detail-wrapper-expanded]="isExpanded(p)">
                                    <div class="example-element-detail" style="padding: 0 50px;">
                                      <mat-radio-group
                                        aria-labelledby="example-radio-group-label"
                                        class="example-radio-group"
                                      >
                                        <mat-radio-button class="example-radio-button" [value]="1">11111111111111</mat-radio-button>
                                        <mat-radio-button class="example-radio-button" [value]="2">22222222222222</mat-radio-button>
                                        <mat-radio-button class="example-radio-button" [value]="3">333333333333333</mat-radio-button>
                                        <mat-radio-button class="example-radio-button" [value]="4">4444444444444444</mat-radio-button>
                                      </mat-radio-group>
                
                                    </div>
                                  </div>
                                </td>
                              </ng-container>

                              <ng-container matColumnDef="fullFooter">
                                <td mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplayWithExpand.length" style="padding: unset">
                                  <div class="row totalPrice-wrapper">
                                    <div class="col align-center" *ngIf="pendingTotal != 0">
                                      <span><b>Pending Total (Ex GST)</b>
                                        <span class="pendingTotal">:&nbsp;{{ totalPriceChange | currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                      </span>
                                    </div>
                                    <div class="col align-center" *ngIf="pendingTotal == 0">
                                      <span>
                                        <b>Pending Total (Ex GST)</b>
                                        <span class="pendingTotal">:&nbsp;{{ 0 | currency:'AUD':'symbol-narrow':'.2-2' }}</span>
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              </ng-container>

                              <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                              <tr mat-row *matRowDef="let p; columns: columnsToDisplayWithExpand;"
                                  class="example-element-row pending-grey-row"
                                  [class.example-expanded-row]="isExpanded(p)"
                                  (click)="toggle(p)">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr mat-footer-row *matFooterRowDef="['fullFooter']"></tr>
                            </table>
                          </div>
                          <div style="padding-top: 75px; margin: 0px 50px;">
                            <mat-checkbox *ngIf="showCreateScheduled()" [(ngModel)]="createScheduled" (change)="totalPriceChange = pendingTotal = calculateTotalPriceChange()">
                              Create this order at Anniversary Date
                            </mat-checkbox>
                          </div>
                          <div class="row">
                            <div class="col button-center ">
                              <button
                                [disabled]="loadingPreview"
                                class="button button-red button-large button-center-right"
                                (click)="downloadExcelAbobeConfirmProducts('Indicative Pricing_' + details?.customer.customer_id, details?.customer)"
                              >
                                Download Quotes
                              </button>
                            </div>
                            <div class="col button-center " *ngIf="!isQuoteCustomer">
                              <button 
                                class="button button-red button-large button-center-right"
                                [disabled]="!authService?.currentUserHasPurchaseAccess() || loadingPreview"
                                [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
                                matTooltip="Requires Purchasing Permissions"
                                (click)="confirmSubscription()"
                              >
                                Place Order
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>

  </div>
</div>